<template>
  <div class="ruKuZuoyeWarp app-container">
    <div class="ruKuZuoyeWarp-body">
      <div>
        <div class="detailsTitle">
          <h4>入库单据</h4>
        </div>
        <!-- 查询条件 -->
        <div ref="searchBox" class="formBox margbot">
          <el-form :inline="true" :model="formData" class="demo-form-inline"  label-width="100px">
             <div class="formItemBox">
            <el-form-item label="车牌号:">
              <el-input class="ipt" v-model="formData.instockPlateNumber" placeholder="请输入车牌号" size="mini"
                 maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
                <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
                <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货权方:">
              <el-select v-model="formData.ownerCustomerTaxId" size="mini" placeholder="请选择货权方" filterable clearable>
                <el-option v-for="(item, index) in HQData" :key="index" :label="item.custerName"
                  :value="item.taxpayerNumber">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期:">
              <div style="display: flex;">
              <el-date-picker v-model="formData.instockDateStart" size="mini" type="datetime" placeholder="选择入库日期"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              -
              <el-date-picker v-model="formData.instockDateEnd" size="mini" placeholder="选择入库日期" type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="产地:">
              <el-select v-model="formData.steelMillName" size="mini" clearable placeholder="请选择">
                <el-option v-for="item in steelMillNameData" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
<el-form-item prop="formData.arrivalMethod" label="到货方式"  >
            <el-select v-model="formData.arrivalMethod" size="mini" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="汽运" value="汽运"></el-option>
              <el-option label="火运" value="火运"></el-option>
              <el-option label="船运" value="船运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库外部单号:">
            <el-input class="ipt" v-model="formData.inExternalNo" placeholder="请输入入库外部单号" size="mini"
              maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="有无货损:">
            <el-select size="mini" v-model="formData.damageflag" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="有货损" value="1"></el-option>
              <el-option label="无货损" value="2"></el-option>
            </el-select>
          </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun" btnCode="003P01AB001" v-if="btnFlg[0]">查询
              </el-button>
              <el-button type="primary" class="button" size="mini" @click="chongZhi" btnCode="003P01AB002"
                v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" class="button" size="mini" @click="daYin" btnCode="003P01AB003"
                v-if="btnFlg[2]">打印入库单</el-button>
              <!-- <el-button type="primary" class="button" size="mini" @click="daYin1" btnCode="003P01AB006"
                v-if="btnFlg[5]">打印入库单</el-button> -->
              <el-button type="primary" class="button" size="mini" btnCode="003P01AB004" v-if="btnFlg[3]"
                @click="editXieCheCost">修改卸车费</el-button>
              <el-button type="primary" class="button" size="mini" btnCode="003P01AB005" v-if="btnFlg[4]"
                @click="daochu">导出</el-button>
              <el-button type="primary" class="button" size="mini" btnCode="003P01AB007" v-if="btnFlg[6]"
                @click="changeRuKuTime">修改入库时间</el-button>
              <span>总吨数：<span style="color: red">{{ allWeightMaster }}</span>吨</span>
              <span style="margin-left:20px">卸车费合计：<span style="color: red">{{ allunloadingCharge }}</span>元</span>
            </el-form-item>
          </div>
          </el-form>
        </div>
        <!-- 表格 -->
        <div :style="{ height: h }">
          <el-table height="100%" size="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row
            @row-click="dianjixuanzhong" @selection-change="handleSelectionChange" @select="selectXiangqingTable"
            @select-all="selectAll" border center bordersize="mini">
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" align="center" width="200">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center" width="180"
              :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车牌号" align="center"
              width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
              width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ownerCustomerName" label="货权方" align="center"
              width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="unloadingCharge" label="卸车费(元)" align="center"
              width="100px">
                <!-- <template scope="scope"> -->
                  <!-- {{scope.row.unloadingCharge==0?'0.00':scope.row.arrivalMethod==undefined?'':scope.row.arrivalMethod==''?'':Number(scope.row.unloadingCharge).toFixed(2)}} -->
                <!-- </template> -->
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.unloadingCharge == undefined || scope.row.unloadingCharge == ''"></span>
                  <span v-if="scope.row.unloadingCharge == 0 ">0.00</span>
                  <span v-else>{{Number(scope.row.unloadingCharge).toFixed(2)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="200">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="200">
              <template scope="scope">
                  {{scope.row.arrivalMethod==1?'汽运':scope.row.arrivalMethod==2?'火运':scope.row.arrivalMethod==3?'船运':scope.row.arrivalMethod}}
                </template>

            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inExternalNo" label="入库外部单号" align="center" width="200">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="200">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"
              :formatter="dateTimeFormat" width="180"></el-table-column>
             <el-table-column :show-overflow-tooltip="true" prop="ext1" label="有无货损" align="center">
                <template v-slot="scope">
                  <div>
                    <el-button type="text" v-if="scope.row.ext2==1" size="small" @click="ckhsFN(scope.row)">有</el-button>
                    <span v-else>无</span>
                  </div>
                </template>
              </el-table-column>
             <el-table-column :show-overflow-tooltip="true" width="180" prop="ext1" label="备注" align="center">
              </el-table-column>
          </el-table>

        </div>
        <!--分页-->
        <div class="pags" style="text-align: right">
          <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
            :page-size="pageInfo.pagesize" :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
          </el-pagination>
        </div>
        <!--货物详情-->
        <div style="margin-top:8px;">
          <div class="detailsTitle">
            <h4>货物详情</h4>
          </div>
          <div ref="searchBox2" style="margin-top: 5px;margin-left:10px;">
            <span>
              总吨数:
              <span style="color: red">{{ allWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ allPoundWeight }}</span> &nbsp;件
            </span>
          </div>
          <!--详情表格-->
          <div class="ruKuZuoyeWarp-body-detailsTab">
            <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
              <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width: 100%"
                :header-cell-style="{
                    background: '#F5F5F5',
                    color: 'black',
                  }" highlight-current-row @row-click="dianjixuanzhongdown" border center bordersize="mini">
                <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
                  width="250"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="150">
                </el-table-column>
                <!-- <el-table-column
                      :show-overflow-tooltip="true"
                      prop="length"
                      label="长度"
                      align="center"
                      width="150"
                    ></el-table-column>
                    <el-table-column
                      :show-overflow-tooltip="true"
                      prop="root"
                      label="单件支数"
                      align="center"
                      width="150"
                    ></el-table-column> -->
                <el-table-column :show-overflow-tooltip="true" prop="singletonWeight" label="单件理重（吨）" align="center"
                  width="150">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.singletonWeight == undefined || scope.row.singletonWeight == ''"></span>
                      <span v-else>{{Number(scope.row.singletonWeight).toFixed(3)}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center"
                  width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                      <span v-else>{{Number(scope.row.allWeight).toFixed(3)}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                      <span v-else>{{Number(scope.row.weight).toFixed(3)}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重(吨)" align="center"
                  width="120">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                      <span v-else>{{Number(scope.row.weighingWeight).toFixed(3)}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="实际过磅时间" align="center"
                  width="180" :formatter="dateTimeFormat"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center"
                  width="150">
                  <template slot-scope="scope">
                    <div>
                      <span v-if="scope.row.factoryWeight == undefined || scope.row.factoryWeight == ''"></span>
                      <span v-else>{{Number(scope.row.factoryWeight).toFixed(3)}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
                  width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"
                  width="120"></el-table-column>
               <!--  <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位" align="center" width="120">
                </el-table-column> -->
                <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center" width="200">
                </el-table-column>
              </el-table>
            </div>
            <!--分页-->
            <div class="pags" style="text-align: right">
              <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
                :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="卸车费修改" :visible.sync="editXieCheVisible" :close-on-click-modal="false" width="50%"
      @close="closeEditQuerenruku" center>
      <el-form ref="xiecheCostEditFormData" label-width="200px" style="width: 500px; margin: 30px auto"
        :model='xiecheCostEditForm'>
        <el-form-item label="车牌号 :" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
          <span style="width: 200px">{{xiecheCostEditForm.plateNumber}}</span>
        </el-form-item>
        <el-form-item label="原卸车费(元):" :rules="[
            {
              required: true,
              message: '请先维护本物料单件理重',
              trigger: 'blur',
            },
          ]">
          <span style="width: 200px">{{xiecheCostEditForm.YxiecheCost}}</span>
        </el-form-item>
        <el-form-item prop="xiecheCost" label="现卸车费(元)：" :rules="[
            {
              required: true,
              message: '请输入卸车费',
              trigger: 'blur',
            },
          ]">
          <el-input v-number-input.float="2" v-model="xiecheCostEditForm.xiecheCost" size="mini" style="width: 200px"
            placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeEditQuerenruku">取 消</el-button>
        <el-button type="primary" :loading="xiecheCostEditLoading" @click="xiecheCostEditRukuOk">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看备注" :visible.sync="dialogBeizhuVisible" width="35%">
      <div v-if="!lookApproverReject">{{beizhu}}</div>
      <span v-if="lookApproverReject">暂无备注</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBeizhuVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 修改入库时间 -->
    <el-dialog title="修改入库时间" :visible.sync="changeTimeVisible" :close-on-click-modal="false" width="40%"
      @close="closeEditChangeTime('changeTimeFormData')" center>
      <el-form ref="changeTimeFormData" label-width="200px" style="width: 500px; margin: 30px auto"
        :model='changeTimeFormData'>
        <el-form-item label="原时间:">
          <span style="width: 200px">{{changeTimeFormData.oldRuKuTime}}</span>
        </el-form-item>
        <el-form-item prop="newRuKuTime" label="修改后时间" :rules="[
            {
              required: true,
              message: '请选择时间',
              trigger: 'blur',
            },
          ]">
          <el-date-picker v-model="changeTimeFormData.newRuKuTime" size="mini" placeholder="选择入库日期" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeEditChangeTime('changeTimeFormData')">取 消</el-button>
        <el-button type="primary" :loading="changeTimeLoading" @click="changeTimeOk('changeTimeFormData')">保 存
        </el-button>
      </div>
    </el-dialog>
     <!-- 查看货损 -->
    <chakanhuosun  v-if="CKHSflag" :CKHSflag.sync="CKHSflag" :rowData="rowData"></chakanhuosun>
  </div>
</template>

<script>
import {
  getThreadMasterList,
  getThreadSummaryList,
  getThreadSummaryTotalWN,
  addOrUpdateThreadMaster,
  getThreadMasterWeightCharge
} from '@/api/wms-access'

import {
  getRelationCustomer,
  zidian,
  getVirtualBalingList,
  changeInstockDate
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'

import {
  exportExcel
} from '@/utils/fileDown.js'
import chakanhuosun from '@/views/wms-access/lwgruku/chakanhuosun.vue'
export default {
  components: {
    chakanhuosun
  },
  data () {
    return {
      formData: {
        instockPlateNumber: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        instockDateStart: '',
        instockDateEnd: '',
        steelMillName: '',
        ownerCustomerTaxId: '' // 货权方
        // productType: ''
      },
      RKData: [],
      HQData: [], // 货权方
      HWData: [],
      btnFlg: [],
      tableData: [],
      allWeight: '0',
      allPoundWeight: '1',
      HWXiangQingLook: true,
      activeName: 'first',
      btnIdArr: [
        '003P01AB001',
        '003P01AB002',
        '003P01AB003',
        '003P01AB004',
        '003P01AB005',
        '003P01AB006',
        '003P01AB007'
      ],
      detailsH: '200px',
      h: '200px',
      detailsData: [], // 详情数据
      pageInfo: {
        pageNo: 1,
        pagesize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      currentXQ: 1,
      total: 0,
      totalXQ: 0,
      xuanzhongArr: null,
      xuanzhongArrdown: null,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      editXieCheVisible: false,
      xiecheCostEditLoading: false,
      xiecheCostEditForm: {
        xiecheCost: '',
        plateNumber: '',
        YxiecheCost: ''
      },
      allWeightMaster: 0,
      allunloadingCharge: 0,
      beizhu: '',
      dialogBeizhuVisible: false,
      lookApproverReject: false,
      steelMillNameData: [],
      // 修改入库时间
      changeTimeVisible: false,
      changeTimeLoading: false,
      changeTimeFormData: {
        oldRuKuTime: '',
        newRuKuTime: ''
      },
      rowData: {},
      CKHSflag: false
    }
  },
  methods: {
    // 查看货损
    ckhsFN (row) {
      this.CKHSflag = true
      this.rowData = row
    },
    chakanbeizhu (row) {
      this.dialogBeizhuVisible = true
      this.beizhu = row.ext1
    },
    getThreadMasterWeightCharges () {
      getThreadMasterWeightCharge({
        ...this.formData,
        instockStatus: '1'
      })
        .then(res => {
          this.allWeightMaster = res.totalAllWeight
          this.allunloadingCharge = res.totalUnloadingCharge
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/instockThread/exportInThreadMasterList', {
          ...this.formData,
          instockStatus: '1',
          ...this.pageInfo
        },
        '入库单据表'
      )
    },
    xiecheCostEditRukuOk () {
      this.$refs.xiecheCostEditFormData.validate((valid) => {
        if (valid) {
          this.xiecheCostEditLoading = true
          addOrUpdateThreadMaster({
            instockId: this.xuanzhongArr.instockId,
            unloadingCharge: this.xiecheCostEditForm.xiecheCost,
            instockStatus: '1'
          })
            .then(res => {
              this.editXieCheVisible = false
              this.getThreadMasterLists()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            })
            .catch(error => {
              this.xiecheCostEditLoading = false

              this.$message({
                message: error.message,
                type: 'error'
              })
            })
        } else {
          this.xiecheCostEditLoading = false
        }
      })
    },
    editXieCheCost () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.editXieCheVisible = true
      this.xiecheCostEditLoading = false
      this.xiecheCostEditForm.xiecheCost = ''
      this.xiecheCostEditForm.plateNumber = ''
      this.xiecheCostEditForm.yuanCost = ''
      this.$nextTick(() => {
        this.$refs.xiecheCostEditFormData.clearValidate()
      })

      this.xiecheCostEditForm.YxiecheCost = this.xuanzhongArr.unloadingCharge
      this.xiecheCostEditForm.plateNumber = this.xuanzhongArr.instockPlateNumber
    },
    closeEditQuerenruku () {
      this.editXieCheVisible = false
    },
    getThreadSummaryTotalWNs () {
      getThreadSummaryTotalWN({
        instockId: this.xuanzhongArr.instockId
      })
        .then(res => {
          console.log(res)
          this.allWeight = res.totalAllWeight
          this.allPoundWeight = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error)
        })
    },
    dianjixuanzhong (row) {
      // console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.getThreadSummaryLists()
      this.getThreadSummaryTotalWNs()
    },
    dianjixuanzhongdown (row) {
      this.xuanzhongArrdown = {}
      this.xuanzhongArrdown = row
      this.getThreadSummaryLists()
    },
    chaxun () {
      this.getThreadMasterLists()
    },
    chongZhi () {
      this.formData.instockPlateNumber = ''
      this.formData.customerTaxId = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockDateStart = ''
      this.formData.instockDateEnd = ''
      this.formData.steelMillName = ''
      this.formData.arrivalMethod = ''
      this.formData.inExternalNo = ''
      this.formData.damageflag = ''

      this.formData.ownerCustomerTaxId = ''
      this.getThreadMasterLists()
    },
    daYin () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/rukuDanPrint1',
        query: {
          id: this.xuanzhongArr.instockId
        }
      })
    },
    daYin1 () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/rukuDanPrint1',
        query: {
          id: this.xuanzhongArr.instockId
        }
      })
    },
    handleSelectionChange () {},
    selectXiangqingTable () {},
    selectAll () {},
    handleCurrentChange (val) {
      console.log(val)
      this.pageInfo.pageNo = val
      this.getThreadMasterLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pagesize = val
      this.getThreadMasterLists()
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.getThreadSummaryLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.getThreadSummaryLists()
    },
    // 主列表显示
    getThreadMasterLists () {
      getThreadMasterList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pagesize,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        instockDateStart: this.formData.instockDateStart,
        instockDateEnd: this.formData.instockDateEnd,
        driverName: this.formData.driverName,
        steelMillName: this.formData.steelMillName,
        arrivalMethod: this.formData.arrivalMethod,
        inExternalNo: this.formData.inExternalNo,
        instockStatus: 1,
        ownerCustomerTaxId: this.formData.ownerCustomerTaxId,
        damageflag: this.formData.damageflag
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tabref1.setCurrentRow(res.list[0])
            })
            this.getThreadSummaryLists()
            this.getThreadMasterWeightCharges()
          } else {
            this.detailsData = []
            this.allWeight = 0
            this.allWeightMaster = 0
            this.allunloadingCharge = 0
            this.allPoundWeight = 0
            this.totalXQ = 0
          }
          this.total = res.total
        })
        .catch(error => {
          console.log(error)
          DonMessage.error(error)
        })
    },
    // 货物详情
    getThreadSummaryLists () {
      getThreadSummaryList({
        instockId: this.xuanzhongArr.instockId,
        steelMillName: this.xuanzhongArr.steelMillName,
        specification: this.xuanzhongArr.specification,
        model: this.xuanzhongArr.model,
        // length: this.xuanzhongArr.length,
        // root: this.xuanzhongArr.root,
        singletonWeight: this.xuanzhongArr.singletonWeight,
        number: this.xuanzhongArr.number,
        allWeight: this.xuanzhongArr.allWeight,
        weight: this.xuanzhongArr.weight,
        weighingWeight: this.xuanzhongArr.weighingWeight,
        weighingDate: this.xuanzhongArr.weighingDate,
        warehouseName: this.xuanzhongArr.warehouseName,
        locationName: this.xuanzhongArr.locationName,
        binName: this.xuanzhongArr.binName,
        sceneUser: this.xuanzhongArr.sceneUser,
        ...this.pageInfoXQ
      })
        .then(res => {
          console.log(res)
          this.detailsData = res.list
          this.xuanzhongArrdown = res.list[0]
          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.list[0])
          })
          this.totalXQ = res.total
          this.getThreadSummaryTotalWNs()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.RKData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({
            'custerName': '无货权方',
            'taxpayerNumber': '-1'
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          // console.log(res)
          this.HWData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 下拉框
    getVirtualBalingLists () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          // this.specificationData = []
          // this.modelData = []
          // this.productTypeData = []
          // var obj = {}
          // for (var i = 0; i < res.length; i++) {
          //   if (!obj[res[i].productTypeName]) {
          //     this.productTypeData.push(res[i])
          //     obj[res[i].productTypeName] = true
          //   }
          // }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          // this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          // this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 修改入库时间
    changeRuKuTime () {
      this.changeTimeVisible = true
      this.changeTimeFormData.oldRuKuTime = this.xuanzhongArr.instockDate
    },
    changeTimeOk (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeTimeLoading = true
          changeInstockDate({
            instockId: this.xuanzhongArr.instockId,
            instockDate: this.changeTimeFormData.newRuKuTime
          })
            .then(res => {
              this.changeTimeLoading = false
              this.changeTimeVisible = false
              this.getThreadMasterLists()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            })
            .catch(error => {
              this.changeTimeLoading = false
              this.$message({
                message: error.message,
                type: 'error'
              })
            })
        } else {
          // this.changeTimeVisible = false
        }
      })
    },
    closeEditChangeTime (formName) {
      this.$refs[formName].resetFields()
      this.changeTimeVisible = false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/RkReceipts')
    this.getThreadMasterLists()
    this.getRelationCustomerS()
    this.zidians()
    this.getVirtualBalingLists()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 125 + 'px'
    this.detailsH = 0.4 * pH - h2 - 70 + 'px'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .ruKuZuoyeWarp {
    width: 100%;
    position: relative;
  }

  .formBox /deep/ .el-form-item{
  margin-bottom: -6px!important;
}
.detailsTitle{
  margin-bottom: 0;
}

</style>
